import { render, staticRenderFns } from "./services.vue?vue&type=template&id=52892f61&scoped=true&"
import script from "./services.vue?vue&type=script&lang=ts&"
export * from "./services.vue?vue&type=script&lang=ts&"
import style0 from "./services.vue?vue&type=style&index=0&id=52892f61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52892f61",
  null
  
)

export default component.exports